import i18n from '@i18next/i18n';
import type { FontList } from './index';

export const fontListMac: FontList = [
    i18n.t('默认字体'),
    ['Microsoft YaHei', i18n.t('雅黑')],
    ['SimSun', i18n.t('宋体')],
    ['SimHei', i18n.t('黑体')],
    ['Hiragino Sans GB', i18n.t('冬青黑简体中文')],
    ['PingFang SC', i18n.t('苹方')],
    ['STSong', i18n.t('华文宋体')],
    ['STFangsong', i18n.t('华文仿宋')],
    ['STKaiti', i18n.t('华文楷体')],
    'Arial',
    'Times New Roman',
    'Calibri',
    'Comic Sans MS',
    'Courier New',
    'Georgia',
    'Microsoft Uighur',
    'Impact',
    'Trebuchet MS',
    'Verdana',
    'Al Bayan',
    'Al Nile',
    'Al Tarikh',
    'American Typewriter',
    'Andale Mono',
    'Arial Black',
    'Arial Hebrew',
    'Arial Hebrew Scholar',
    'Arial Narrow',
    'Arial Rounded MT Bold',
    'Arial Unicode MS',
    'Athelas',
    'Avenir',
    'Avenir Next',
    'Avenir Next Condensed',
    'Ayuthaya',
    'Baghdad',
    'Bangla MN',
    'Bangla Sangam MN',
    'Baskerville',
    'Beirut',
    'Big Caslon',
    'Bodoni',
    'Bodoni 72 Oldstyle',
    'Bodoni 72 Smallcaps',
    'Bodoni Ornaments',
    'Bradley Hand',
    'Brush Script MT',
    'Chalkboard',
    'Chalkboard SE',
    'Chalkduster',
    'Charter',
    'Cochin',
    'Copperplate',
    'Corsiva Hebrew',
    'Courier',
    'Damascus',
    'DecoType Naskh',
    'Devanagari MT',
    'Devanagari Sangam MN',
    'Didot',
    'DIN Alternate',
    'DIN Condensed',
    'Diwan Kufi',
    'Diwan Thuluth',
    'Euphemia UCAS',
    'Farah',
    'Farisi',
    'Futura',
    'GB18030 Bitmap',
    'Geeza Pro',
    'Geneva',
    'Gill Sans',
    'Gujarati MT',
    'Gujarati Sangam MN',
    'Gurmukhi MN',
    'Gurmukhi MT',
    'Gurmukhi Sangam MN',
    'Hei',
    'Helvetica',
    'Helvetica Neue',
    'Herculanum',
    'Hiragino Kaku Gothic Pro',
    'Hiragino Kaku Gothic ProN',
    'Hiragino Kaku Gothic Std',
    'Hiragino Kaku Gothic StdN',
    'Hiragino Maru Gothic Pro',
    'Hiragino Maru Gothic ProN',
    'Hiragino Mincho Pro',
    'Hiragino Mincho ProN',
    'Hiragino Sans',
    'Hoefler Text',
    'InaiMathi',
    'Iowan Old Style',
    'ITF Devanagari',
    'ITF Devanagari Marathi',
    'Kai',
    'Kailasa',
    'Kannada MN',
    'Kannada Sangam MN',
    'Kefa',
    'Khmer MN',
    'Khmer Sangam MN',
    'Kohinoor Bangla',
    'Kohinoor Devanagari',
    'Kohinoor Telugu',
    'Kokonor',
    'Krungthep',
    'KufiStandardGK',
    'Lao MN',
    'Lao Sangam MN',
    'Lucida Grande',
    'Luminari',
    'Malayalam MN',
    'Malayalam Sangam MN',
    'Marion',
    'Marker Felt',
    'Menlo',
    'Microsoft Sans Serif',
    'Mishafi',
    'Mishafi Gold',
    'Monaco',
    'Mshtakan',
    'Muna',
    'Myanmar MN',
    'Myanmar Sangam MN',
    'Nadeem',
    'New Peninim MT',
    'Noteworthy',
    'Noto Nastaliq Urdu',
    'Optima',
    'Oriya MN',
    'Oriya Sangam MN',
    'Palatino',
    'Papyrus',
    'Phosphate',
    'Plantagenet Cherokee',
    'PT Mono',
    'PT Sans',
    'PT Sans Caption',
    'PT Sans Narrow',
    'PT Serif',
    'PT Serif Caption',
    'Raanana',
    'Sana',
    'Sathu',
    'Savoye LET',
    'Seravek',
    'Shree Devanagari',
    'SignPainter',
    'Silom',
    'Sinhala MN',
    'Sinhala Sangam MN',
    'Skia',
    'Snell Roundhand',
    'STIXGeneral',
    'STIXIntegralsD',
    'STIXIntegralsSm',
    'STIXIntegralsUp',
    'STIXIntegralsUpD',
    'STIXIntegralsUpSm',
    'STIXNonUnicode',
    'STIXSizeFiveSym',
    'STIXSizeFourSym',
    'STIXSizeOneSym',
    'STIXSizeThreeSym',
    'STIXSizeTwoSym',
    'STIXVariants',
    'Sukhumvit Set',
    'Superclarendon',
    'Symbol',
    'Tahoma',
    'Tamil MN',
    'Tamil Sangam MN',
    'Telugu MN',
    'Telugu Sangam MN',
    'Thonburi',
    'Times',
    'Trattatello',
    'Waseem',
    'Webdings',
    'Wingdings',
    'Zapf Dingbats',
    'Zapfino',
    'Apple Braille',
    'Apple Chancery',
    'Apple Color Emoji',
    'Apple SD Gothic Neo',
    'Apple Symbols',
    'AppleGothic',
    'AppleMyungjo',
];
